<template>
  <div class="ps-text-field">
    <div v-if="label" class="pb-2">
      {{ skipTranslation ? label : $t(label) }}
    </div>
    <v-text-field
      color="primary"
      :placeholder="placeholder"
      v-bind:rounded="rounded"
      v-bind:flat="flat"
      v-bind:outlined="outlined"
      v-bind:dense="dense"
      v-bind:disabled="disabled"
      v-bind:hide-details="hideDetails"
      v-bind="$attrs"
      v-on="$listeners"
      v-model="model"
      v-bind:error-messages="errorMessages"
      v-bind:counter="counter && maxlength ? maxlength : counter"
      v-bind:type="typeShow"
      v-bind:filled="filled"
      v-bind:maxlength="maxlength ? maxlength : null"
      :background-color="backgroundColor || undefined"
    >
      <template v-slot:append>
        <slot name="append" />
      </template>
      <template v-slot:append-outer>
        <slot name="append-outer" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {},
    flat: { type: Boolean, default: false },
    label: { type: String, require: true },
    errorMessages: { type: Array, require: true },
    outlined: { type: Boolean, default: true },
    dense: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    counter: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    typeShow: { type: String, default: "text" },
    placeholder: { type: String, default: "" },
    maxlength: { type: Number, default: 0 },
    skipTranslation: { type: Boolean, default: false },
    backgroundColor: { type: String, default: "" },
  },
  data() {
    return {
      model: this.value,
    };
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) this.model = newVal;
    },
    model(newVal, oldVal) {
      if (newVal !== oldVal) this.$emit("input", newVal);
    },
  },
  computed: {
    hideDetails() {
      if (this.errorMessages && this.errorMessages.length) {
        return "auto";
      }
      // Show counter if enabled, even when there are no errors
      if (this.counter) {
        return "auto";
      }
      return "auto";
    },
  },
};
</script>

<style></style>
